<template>
  <div @click="handleClick" :class="[bem.b()]">
    <template v-if="drag">
      <upload-dragger @file="uploadFiles">
        <slot></slot>
      </upload-dragger>
    </template>
    <template v-else>
      <slot></slot>
    </template>
    <input
      type="file"
      ref="inputRef"
      :name="name"
      :accept="accept"
      :multiple="multiple"
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { getId, UploadRawFile } from './upload'
import { createNamespace } from '@chenms-zj/utils/create'
import { uploadContentProps } from './upload-content'
import { httpRequest } from './ajax'
import uploadDragger from './upload-dragger.vue'

defineOptions({
  name: 'cms-upload-content',
  inheritAttrs: false
})

const props = defineProps(uploadContentProps)

const bem = createNamespace('upload')

const inputRef = ref<HTMLInputElement>()
const handleClick = () => {
  inputRef.value!.value = ''
  inputRef.value!.click()
}

const upload = async (rawFile: UploadRawFile) => {
  // 上传之前输入框清空
  inputRef.value!.value = ''
  const result = await props.beforeUpload(rawFile)
  // 停止上传
  if (result === false) return props.onRemove(rawFile)

  const { method, name, action, headers, data } = props
  httpRequest({
    method,
    name,
    file: rawFile,
    action,
    headers,
    data,
    onError: e => {
      props.onError(e, rawFile)
    },
    onSuccess: res => {
      props.onSuccess(res, rawFile)
    },
    onProgress: e => {
      props.onProgress(e, rawFile)
    }
  })
}

function uploadFiles(files: FileList) {
  for (let i = 0; i < files.length; i++) {
    const rawFile = files[i] as UploadRawFile
    rawFile.uid = getId()
    props.onStart(rawFile)
    upload(rawFile)
  }
  console.log(files)
}
const handleChange = (e: Event) => {
  const files = (e.target as HTMLInputElement).files!
  uploadFiles(files)
}
</script>

<style scoped></style>
